import { environment } from 'src/environments/environment';

export const progInfoConstants = {

    GLOBAL_ENTRY_INFO: {
        name: 'Global Entry',
        code: 'UP',
        description: 'HOME.UP_STREAMLINED_FOR',
        logo: 'assets/images/logos/logo-global-entry.png',
        logoAlt: 'IMAGE_ALT.GLOBAL_ENTRY_LOGO',
        bestFor: 'HOME.UP_CARD_FOR',
        benefits: [
                {
                    icon: '<i class="uswds-icon icon-clock"></i>',
                    description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.UP.BENEFITS.WAIT_TIME'
                },
                {
                    icon: '<i class="uswds-icon icon-plane"></i>',
                    description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.UP.BENEFITS.AIRPORTS'
                },
                {
                    icon: '<image class="benefit-image" src="assets/images/logos/tsaprecheck-official.png" alt="TSA Precheck">',
                    description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.UP.BENEFITS.PRECHECK'
                },
                {
                    icon: '<i class="fa-solid fa-car"></i>',
                    description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.UP.BENEFITS.BORDERS'
                }
        ],
        costHeader: {
            price: environment.programPrices.UP,
            costInfo: ['HOME.FOR_5_YEARS', 'HOME.MINORS_FREE']
        },
    },

    TSA_INFO: {
        name: 'TSA PreCheck',
        code: 'TSA',
        bestFor: 'PROGRAM_LANDING_PAGE.TSA.BEST_FOR',
        logo: 'assets/images/logos/logo-global-entry.png',
        logoAlt: 'IMAGE_ALT.GLOBAL_ENTRY_LOGO',
        benefits: [
            {
                icon: '<i class="fa-solid fa-users"></i>',
                description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.TSA.BENEFITS.LANES'
            }
        ],
        costHeader: {
            price: environment.programPrices.TSA
        }
    },

    NEXUS_INFO: {
        name: 'NEXUS',
        code: 'NH',
        bestFor: 'HOME.NH_CARD_FOR',
        logo: 'assets/images/logos/logo-nexus.png',
        logoAlt: 'IMAGE_ALT.NEXUS_LOGO',
        description: 'HOME.NH_STREAMLINED_FOR',
        benefits: [
            {
                icon: '<i class="uswds-icon icon-car"></i>',
                description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.NH.BENEFITS.LANES'
            },
            {
                icon: '<i class="uswds-icon icon-plane"></i>',
                description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.NH.BENEFITS.GLOBAL_ENTRY'
            },
            {
                icon: '<i class="uswds-icon icon-ship"></i>',
                description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.NH.BENEFITS.SEA'
            },
            {
                icon: '<image class="benefit-image" src="assets/images/logos/tsaprecheck-official.png" alt="TSA Precheck">',
                description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.NH.BENEFITS.PRECHECK'
            },        
        ],
        costHeader: {
            price: environment.programPrices.NH,
            costInfo: ['HOME.FOR_5_YEARS']
        },
    },

    SENTRI_INFO: {
        name: 'SENTRI',
        code: 'SH',
        bestFor: 'HOME.SH_CARD_FOR',
        logo: 'assets/images/logos/logo-sentri.png',
        logoAlt: 'IMAGE_ALT.SENTRI_LOGO',
        description: 'HOME.SH_STREAMLINED_FOR',
        benefits: [
            {
                icon: '<i class="uswds-icon icon-car"></i>',
                description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.SH.BENEFITS.PROCESSING_LANES'
            },
            {
                icon: '<i class="uswds-icon icon-car"></i>',
                description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.SH.BENEFITS.NEXUS'
            },
            {
                icon: '<i class="uswds-icon icon-plane"></i>',
                description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.SH.BENEFITS.GLOBAL_ENTRY'
            },
        ],
        costHeader: {
            price: environment.programPrices.SH,
            costInfo: ['HOME.FOR_5_YEARS']
        },
    },

   FAST_INFO: {
        name: 'FAST',
        code: 'FAST',
        bestFor: 'HOME.FAST_CARD_FOR',
        logo: 'assets/images/logos/logo-us-mexico-fast.jpg',
        logoAlt: 'IMAGE_ALT.FAST_LOGO',
        description: 'HOME.FAST_STREAMLINED_FOR',
        benefits: [
            {
                icon: '<i class="uswds-icon icon-clock"></i>',
                description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.FAST.BENEFITS.PROCESSING_TIME'
            },
            {
                icon: '<i class="fa-solid fa-check"></i>',
                description: 'HOME.COMPARISON_STEPPER.RECOMMENDATION.FAST.BENEFITS.LANES'
            },
        ],
        costHeader: {
            price: environment.programPrices.FAST,
            costInfo: ['HOME.FOR_5_YEARS']
        },
    }
};
